import { render } from "./DynamicFormImages.vue?vue&type=template&id=6224750e&ts=true"
import script from "./DynamicFormImages.vue?vue&type=script&lang=ts"
export * from "./DynamicFormImages.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__